import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {clearOneProduct, addToCart} from "../../actionCreators";

class PopupAddCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmittedForm: false,
      quantity: '',
      cost: '',
      size: '',
      installation: false,
      bringInWindow: false,
      isErrorQuantity: false,
      isErrorCost: false,
      isErrorSize: false
    };
  }

  handleClosePopup = () => {
    const {clearOneProduct} = this.props;
    clearOneProduct();
    this.handleClearFields();
  };

  handleAddToCart = () => {
    const {selectedProduct} = this.props;
    const {quantity, cost, size, installation, bringInWindow, isErrorQuantity, isErrorCost, isErrorSize} = this.state;
    const {handleAddingToCart} = this;
    this.setState({
      isSubmittedForm: true
    });
    const product = selectedProduct[0];

    const isProductPrice = product.should_enter_price;
    const isProductSize = product.should_enter_size;

    if(quantity) product.quantity = JSON.parse(quantity);
    if(cost) product.cost = JSON.parse(cost);
    if(size) product.size = JSON.parse(size);
    product.installation = installation ? installation : false;
    product.bringInWindow = bringInWindow ? bringInWindow : false;
    if(isProductSize && isProductPrice) {
      if(quantity && cost && size && isErrorQuantity && isErrorSize && isErrorCost) handleAddingToCart(product);
    } else if(isProductSize) {
      if(quantity && size && isErrorSize && isErrorQuantity) handleAddingToCart(product);
    } else if(isProductPrice){
      if(quantity && cost && isErrorQuantity && isErrorCost) handleAddingToCart(product);
    } else {
      if(quantity && isErrorQuantity) handleAddingToCart(product);
    }
  };

  handleAddingToCart = (product) => {
    const {clearOneProduct} = this.props;
    const {handleClearFields} = this;
    this.props.addToCart(product);
    clearOneProduct();
    handleClearFields();
  }

  handleClearFields = () => {
    this.setState({
      isSubmittedForm: false,
      quantity: '',
      cost: '',
      size: '',
      installation: false,
      bringInWindow: false,
      isErrorQuantity: false,
      isErrorCost: false,
      isErrorSize: false
    });
  };

  handleValidate = (e, regexp, nameError) => {
    const target = e.target;
    const value = target.value;
    let intPos = /^[1-9]\d*$/;
    let floatTwo = /^\d+(,\d{2})?$/;
    if(regexp === 'intPos') {
      this.setState({
        [nameError]: intPos.test(value)
      });
    } else {
      this.setState({
        [nameError]: floatTwo.test(value)
      });
    }
  };

  handleInputChange = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  render() {
    const {handleValidate} = this;
    const {showPopup, selectedProduct, selectedCategory} = this.props;
    const {cost, size, quantity, installation, bringInWindow, isSubmittedForm, isErrorQuantity, isErrorSize, isErrorCost} = this.state;
    const categoryName = selectedCategory.length ? selectedCategory[0].name : '';
    const isProductPrice = selectedProduct.length ? selectedProduct[0].should_enter_price : '';
    const isProductSize = selectedProduct.length ? selectedProduct[0].should_enter_size : '';
    return (
      <Fragment>
        {showPopup ? (
          <div>
            <div className="overflow-popup" onClick={this.handleClosePopup}></div>
            <div className="popup-category">
              <div className="popup-category__wrap">
                <h3>Kategorie: {categoryName} *</h3>
                <div className={"input-wrap input-wrap--common " + (!quantity && isSubmittedForm && !isErrorQuantity ? ' form__error' : '')}>
                  <div className="input-wrap--unit">Stk.</div>
                  <label>Anzahl</label>
                  <input type="text" name="quantity" value={quantity} onChange={(e) => {this.handleInputChange(e); handleValidate(e, 'intPos', 'isErrorQuantity')}} required />
                </div>
                {!isErrorQuantity && isSubmittedForm ? <div className="form__error form__error--text">Bitte tragen Sie die Anzahl der Artikel aus einer Kategorie ein</div> : ''}
                {isProductPrice ? (
                  <div className={"input-wrap input-wrap--common " + (!cost && isProductPrice && isSubmittedForm && !isErrorCost ? ' form__error' : '')}>
                    <div className="input-wrap--cost">&euro;</div>
                    <label>Preis je Artikel</label>
                    <input type="text" name="cost" value={cost} onChange={(e) => {this.handleInputChange(e); handleValidate(e, 'floatTwo', 'isErrorCost')}} required />
                  </div>
                ) : ( '' )}
                {!isErrorCost && isSubmittedForm && isProductPrice ? <div className="form__error form__error--text">Bitte tragen Sie den Kaufpreis Ihres Artikels ein</div> : ''}
                {isProductSize ? (
                  <div className={"input-wrap input-wrap--common " + (!size && isProductSize && isSubmittedForm && !isErrorSize ? ' form__error' : '')}>
                    <div className="input-wrap--unit">m</div>
                    <label>Gesamtlänge je Artikel</label>
                    <input type="text" name="size" value={size} onChange={(e) => {this.handleInputChange(e); handleValidate(e, 'floatTwo', 'isErrorSize')}} required />
                  </div>
                ) : ( '' )}
                {!isErrorSize && isSubmittedForm && isProductSize ? <div className="form__error form__error--text">Bitte tragen Sie die Länge in Meter ein</div> : ''}
                <div className="check-wrap check-wrap--common">
                  <input type="checkbox" name="installation" id="installation" checked={installation} onChange={this.handleInputChange} required />
                  <label htmlFor="installation">Montage erwünscht</label>
                </div>
                <div className="check-wrap check-wrap--common">
                  <input type="checkbox" name="bringInWindow" id="bringInWindow" checked={bringInWindow} onChange={this.handleInputChange} required />
                  <label htmlFor="bringInWindow">
                    <p>passt nicht durch die Tür / Treppenhaus</p>
                  </label>
                </div>
                <p className="popup-category__desc">- * Weitere Artikel, z.B. aus einer anderen Kategorie oder mit einer anderen Größe oder Kaufpreis können Sie nach Bedarf im nächsten Schritt hinzufügen.</p>
                <div className="popup-category__btns">
                  <button className="popup-category__btn-cancel" type="button" onClick={this.handleClosePopup}>Stornieren</button>
                  <button className="popup-category__btn-add" type="button" onClick={this.handleAddToCart}>hinzufügen</button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </Fragment>
    );
  }
}

export default connect((state) => {
  return {
    selectedProduct: state.categories.selectedProduct,
    selectedCategory: state.categories.selectedCategory,
    showPopup: state.categories.showPopupAddCart,
  }
}, {clearOneProduct, addToCart})(PopupAddCart);


// WEBPACK FOOTER //
// ./src/components/Popups/PopupAddCart.js